<a [routerLink] = "link" [class]="'block text-white bg-[var(--red)] text-[13px] uppercase font-bold px-[27px] py-[12px] rounded-[10px] hover:bg-[var(--red-hover)] transition-all ' + cssClasses">
    <ng-content></ng-content>
</a>